import { render, staticRenderFns } from "./Remotions.vue?vue&type=template&id=1d950613"
import script from "./Remotions.vue?vue&type=script&lang=js"
export * from "./Remotions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports